import React from "react";

function MenuItemDivider() {
  return (
    <div className="row">
      <div className="col-12">
        <div className="group-divider"></div>
      </div>
    </div>
  );
}

export default MenuItemDivider;
